var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeWayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 495",
    cx: 40.0072,
    cy: 40.0072,
    r: 40.0072,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M29.7745 43.4345V39.7662C33.0113 40.4136 35.1691 41.4925 37.327 44.5135C37.3989 43.938 38.0403 42.4767 38.9034 40.9231C36.0982 38.3336 31.5008 36.7452 29.7745 36.7452V33.0769L24.5957 38.2557L29.7745 43.4345Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M39.8207 37.1049L40.7495 38.6154C41.547 37.6923 42.3674 37.1049 43.0572 36.7692L43.0575 26.963H46.5101L41.547 22L36.584 26.963H39.8207V37.1049Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M39.8203 50.0161V56.4896C39.8203 56.9931 40.1656 58.0001 41.5466 58.0001C42.9276 58.0001 43.129 56.9931 43.0571 56.4896V50.0161C43.0571 44.492 46.2882 41.6005 50.6095 41.6005V45.2688L55.7883 40.09L50.6095 35.127V38.3637C43.2729 38.3637 39.8203 44.6154 39.8203 50.0161Z",
    fill: "#E60000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeWayArrow);
export default __webpack_public_path__ + "static/media/three-way-arrow.59e33576d42e42a857654e13fb5fc16d.svg";
export { ForwardRef as ReactComponent };